<ng-template ngFor let-documento [ngForOf]="documenti" let-idx=false>

<li *ngIf="!!fascicolo; else noFascicolo">
	<div class="documento" [ngClass]="{'controparte': subdoc}">
		<div>
		 <!-- {{documento.contentType}} -->
			<p
				[ngClass]="getIconByContentType(documento.contentType)" class="tipodoc"> {{
				(documento.tipoDocumento && documento.tipoDocumento.descrizione) ?
				documento.tipoDocumento.descrizione: '' }}</p>
			<p class="categoria">{{(fascicolo.tipoFascicolo &&
				fascicolo.tipoFascicolo.label) ? fascicolo.tipoFascicolo.label: ''}}</p>
			<p class="codice">{{documento.posizione | slice:0:11}}{{documento.posizione | slice:23:27}} </p>
		</div>
		<div class="secondo_blocco">
			<p class="identificativo">
					<span title="{{fascicolo.praticaBase.intestazione.campi.posizionePratica}}">{{fascicolo.praticaBase.intestazione.campi.posizionePratica}}</span>
					&nbsp;
					<span title="{{fascicolo.intestazione.campi.posizione}}">{{fascicolo.intestazione.campi.posizione}}</span>
			</p>
			<h4 class="titolo">{{ documento.titolo }}</h4>
		</div>
		<div *ngIf="documento?.flagTimbratura" class="secondo_blocco" style="margin-left: 2%;margin-top: 0.5%;">
			<li style="display: inline-flex; align-items: center;">
				<img src="img/stamp.png" alt="Documento timbrato" title="Documento timbrato" style="width: 18px; height: 18px; vertical-align: middle;">
			</li>
		</div>
		<div class="data_opzioni tipo_doc">
			<ul>
				<li>
					<a href="javascript:void(0)" *ngIf="canViewFile(documento)" (click)="viewDoc(documento)">
						<span style="color:#337ab7!important" class="glyphicon glyphicon-eye-open"></span>
					</a>
					<span 
						style="color:#337ab7!important" 
						*ngIf="!canViewFile(documento)" 
						class="glyphicon glyphicon-eye-close"
						[appTooltip]="'L’anteprima non è disponibile perché il file supera le dimensioni massime consentite'" 
						[appTooltipEnabled]="checkMaxLimitExceeded(documento)">
					</span>
				</li>
				<li class="opzioni" appDropdownFocus><a class="dropdown-toggle"
					data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
					aria-expanded="true">Opzioni<span
						class="glyphicon glyphicon-option-vertical"></span></a>
					<div class="dropdown-menu">
						<ul>
							<li><span class="glyphicon glyphicon-save-file"></span><a
								href="javascript:void(0);" (click)="downloadFile(documento.id);">Download
									documento</a></li>
							<li *ngIf="writable"><span
								class="glyphicon glyphicon-open-file"></span><a
								href="javascript:void(0);"
								(click)="openModalCallback(documento)">Upload nuova versione</a></li>
							<li *ngIf="writable"><span class="glyphicon glyphicon-edit"></span>
								<a href="javascript:void(0)"
								(click)="openUpdateMetadatiModal(documento)">Modifica
									metadati documento</a></li>
							<li><span class="glyphicon glyphicon-calendar"></span><a
								href="javascript:void(0);"
								(click)="openHistoryModalCallback(documento)">Visualizza
									storico versioni</a></li>
							<!-- I documenti non possono essere eliminati dalla sezione Censimento Documenti -->
							<li *ngIf="writable"><span
								class="glyphicon glyphicon-trash"></span><a
								href="javascript:void(0);"
								(click)="deleteDoc(documento, entityId, nomeCampoId)">Elimina
									documento</a></li>
						</ul>
					</div></li>
				<ng-template [ngIf]="subdoc">
				<li><a [attr.data-toggle]="'collapse'" class="legale collapsed"
					href="#subdocumentazione{{documento.id}}" aria-expanded="false"
					[attr.aria-controls]="'subdocumentazione'+documento.id"
					[attr.data-parent]="'#controparticollapse'"> <span>Apri</span></a>
				</li>
				</ng-template>
			</ul>
		</div>
	</div> <ng-template [ngIf]="subdoc">
	<div id="subdocumentazione{{documento.id}}"
		class="collapse subdocumentazione">
		<form>
			<div class="row">
				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Posizione'" [valueInput]="documento.posizione"></div>
				<div labelTextInput class="col-sm-5 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Titolo'" [valueInput]="documento.titolo"></div>
				<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Tipologia'"
					[valueInput]="(documento.tipoDocumento ? documento.tipoDocumento.label : '')"></div>
			</div>
			<div class="row">
				<div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Provenienza'"
					[valueInput]="((documento.provenienza && documento.provenienza.label) ? documento.provenienza.label: '')"></div>
				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Data riferimento'"
					[valueInput]="(documento.dataRiferimento ? (documento.dataRiferimento | date:'dd/MM/yyyy'): '')"></div>
				<div labelTextInput class="col-sm-5 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Nome file'"
					[valueInput]="(documento.nomeFile ? documento.nomeFile: '')"></div>
				<div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Numero versione'"
					[valueInput]="(((documento.versione === '') || !documento.versione) ? '1.0' : documento.versione)"></div>
			</div>
			<div class="row">
				<div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Autore'"
					[valueInput]="(documento.autore ? documento.autore: '')"></div>
				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Data caricamento'"
					[valueInput]="(documento.dataCaricamento ? (documento.dataCaricamento | date:'dd/MM/yyyy'): '')"></div>
				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Utente ultima modifica'"
					[valueInput]="(documento.utenteAggiornamento ? documento.utenteAggiornamento: '')"></div>
				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Data ultima modifica'"
					[valueInput]="(documento.dataAggiornamento ? (documento.dataAggiornamento | date:'dd/MM/yyyy'): '')"></div>
			</div>
			<div class="row">
				<div class="col-sm-12 bloccodati">
					<p>
						<label class="col-sm-12">Note</label>
						<span class="longtext" *ngIf="documento.note">{{ documento.note }}</span>
					</p>
				</div>
<!-- 				<div labelTextInput class="col-sm-12 bloccodati" -->
<!-- 					[typeLabel]="'text'" [labelInput]="'Note'" -->
<!-- 					[valueInput]="documento.note"></div> -->
			</div>
			<div class="row" *ngIf="writable">
				<p class="col-sm-3 col-sm-offset-9 col-xs-3 col-xs-offset-9">
					<button type="button" class="btn btn-primary btn-block"
						(click)="openUpdateMetadatiModal(documento)">Modifica
						dati</button>
				</p>
			</div>
		</form>
	</div>
	</ng-template>
</li>


	<ng-template #noFascicolo>
		<li>
			<div class="documento-no-fascicolo" style="display: flex; align-items: center;" [ngClass]="{'controparte': subdoc}">
				<div style="margin-left: 0!important; float: none!important; width: 100%!important;">
					<!-- <p class="doc-icon"></p> -->
					<div class="row row-doc">
						<div class="col-sm-2 col-xs-2" style="text-align: center;">
							<p class="doc-icon"></p>
						</div>				
						<div class="col-sm-4 col-xs-4" style="text-align: center;">
							<p style="font-weight: 600;">
								{{documento.nomeFile ? documento.nomeFile : ' - '}}
							</p>
						</div>
						<div class="col-sm-4 col-xs-4" style="text-align: center;">
							<p style="font-weight: bold; color: #0b59a4;">
								{{documento.tipoDocumento.descrizione ? documento.tipoDocumento.descrizione : ' - '}}
							</p>
						</div>
						<div class="col-sm-2 col-xs-2" style="text-align: center;">
							<p style="font-weight: bold; color: black;">
								<span *ngIf="documento.flagAllegatoPrincipale" class="glyphicon glyphicon-star"></span>
								<span *ngIf="!documento.flagAllegatoPrincipale" class="glyphicon glyphicon-paperclip"></span>
							</p>
						</div>
					</div>
				</div>
			</div> 
		</li>
	</ng-template>
</ng-template>